import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
import * as yup from 'yup';
const FIELD_NAME = 'turnstileToken';
interface FormikBag {
  setFieldValue: (field: string, value: string, shouldValidate?: boolean) => void;
  setFieldError: (field: string, message: string) => void;
  setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void;
}
export function getTurnstileSiteKey(): string {
  const isDatadogTest = typeof navigator !== 'undefined' && navigator.userAgent.includes('DatadogSynthetics');
  return (isDatadogTest ? process.env.NEXT_PUBLIC_TURNSTILE_TEST_SITE_KEY : process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY) || process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY || '';
}
export const turnstileTokenSchema = yup.string().required('Verification failed. Please try again.');
export function useTurnstile(formik) {
  const $ = _c(11);
  let t0;
  if ($[0] !== formik) {
    t0 = token => {
      formik.setFieldValue(FIELD_NAME, token, false);
      formik.setFieldTouched(FIELD_NAME, false, false);
    };
    $[0] = formik;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onVerify = t0;
  let t1;
  if ($[2] !== formik) {
    t1 = () => {
      formik.setFieldValue(FIELD_NAME, "", false);
      formik.setFieldError(FIELD_NAME, "Verification failed. Please try again.");
      formik.setFieldTouched(FIELD_NAME, true, false);
    };
    $[2] = formik;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onError = t1;
  let t2;
  if ($[4] !== formik) {
    t2 = () => {
      formik.setFieldValue(FIELD_NAME, "", false);
      formik.setFieldError(FIELD_NAME, "Verification expired. Please try again.");
      formik.setFieldTouched(FIELD_NAME, true, false);
    };
    $[4] = formik;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onExpire = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getTurnstileSiteKey();
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const siteKey = t3;
  let t4;
  if ($[7] !== onError || $[8] !== onExpire || $[9] !== onVerify) {
    t4 = {
      siteKey,
      onVerify,
      onError,
      onExpire
    };
    $[7] = onError;
    $[8] = onExpire;
    $[9] = onVerify;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}